export default __webpack_public_path__ + "image-distributef9bebb.png";